import * as PIXI from 'pixi.js';
import { TweenManager } from 'framework/TweenManager/TweenManager';
import { PoolGroup } from 'framework/utils/PoolGroup';
import { RandomDataGenerator } from 'framework/RandomDataGenerator/RandomDataGenerator';
import { IAnimationDependencies } from 'js/bubbleCore/view/animations/types';

let tweenManager: TweenManager | null = null;
let spritePool: PoolGroup<PIXI.Sprite> | null = null;
let rnd: RandomDataGenerator | null = null;
let animatedPool: PoolGroup<PIXI.extras.AnimatedSprite> | null = null;

export function fillAnimationDependencies(
  dep: Partial<IAnimationDependencies>
): IAnimationDependencies {
  return {
    tweenMgr: dep.tweenMgr || getTweenManager(),
    spritePool: dep.spritePool || getSpritePool(),
    animatedPool: dep.animatedPool || getAnimatedSpritePool(),
    rnd: dep.rnd || getRND(),
  }
}

function getTweenManager(): TweenManager {
  if (tweenManager === null) {
    tweenManager = new TweenManager();
    PIXI.ticker.shared.add(() => tweenManager!.update(PIXI.ticker.shared.elapsedMS));
  }
  return tweenManager;
}

function getSpritePool(): PoolGroup<PIXI.Sprite> {
  if (spritePool === null) spritePool = PoolGroup.createSpritePool();
  return spritePool;
}

function getRND(): RandomDataGenerator {
  if (rnd === null) rnd = new RandomDataGenerator([Math.random()]);
  return rnd;
}

function getAnimatedSpritePool(): PoolGroup<PIXI.extras.AnimatedSprite> {
  if (animatedPool === null) {
    animatedPool = new PoolGroup<PIXI.extras.AnimatedSprite>(
      () => new PIXI.extras.AnimatedSprite([PIXI.Texture.EMPTY]),
      (sprite) => {
        sprite.stop();
        sprite.position.set(0);
        sprite.anchor.set(0.5);
        sprite.loop = false;
        sprite.alpha = 1;
        sprite.onComplete = () => {};
        sprite.onLoop = () => {};
        sprite.gotoAndStop(0);
      },
      (sprite) => sprite.destroy(),
    );
  }
  return animatedPool;
}